import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { userClient } from '../client/userClient';


type Options = {
  enabled: boolean
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useUsers = (params: Users.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getUsers, params],
    queryFn: () => userClient.getUsers(params),
  });

  return {
    ...rest,
    count: data?.count || 0,
    users: data?.results || [],
  };
};
